// extracted by mini-css-extract-plugin
export var assigneeBadge = "_le-0";
export var assigneeDetails = "_le-1";
export var assigneeInfo = "_le-2";
export var dropdownContainer = "_le-4";
export var dropdownImage = "_le-5";
export var editAssigneeInfo = "_le-3";
export var editAssigneeModalContainer = "_le-6";
export var hidden = "_le-8";
export var input = "_le-7";